<div class="execution-details-container">
  <div class="header-row">
    <h3>
      @if (executionId) {
        Execution Results - #{{ executionId }}
        @if (executionDescription) {
          <span> ({{ executionDescription }})</span>
        }
      } @else {
        Execution Results
      }
    </h3>
    <div class="header-actions">
      @if (loading) {
        <span class="loading-indicator">
          <i class="pi pi-spinner pi-spin"></i>
          Loading...
        </span>
      }
      <span class="search-input">
        <p-iconField iconPosition="left">
          <p-inputIcon class="pi pi-search"></p-inputIcon>
          <input id="detailSearch"
                 pInputText type="text"
                 [ngModel]="filterText"
                 (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                 placeholder="Search Results" />
        </p-iconField>

      </span>
      <p-button
        class=" refresh-btn"
        severity="contrast"
        icon="pi pi-refresh"
        label="Refresh"
        [disabled]="loading || !executionId"
      (click)="refreshDetails()"></p-button>
    </div>
  </div>

  <p-table
    #dt
    [value]="details"
    [globalFilterFields]="['accountLabel','user','campaignAdGroupName','result']"
    responsiveLayout="scroll"
    [paginator]="true"
    [rows]="20"
    class="exec-details-p-table p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-account">Account</th>
        <th class="col-user">User</th>
        <th class="col-campaign">Campaign/Ad Group</th>
        <th class="col-start">Start</th>
        <th class="col-complete">Complete</th>
        <th class="col-result">Result</th>
        <th class="col-error">Error Message</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="col-account">
          @if (row.accountName) {
            <span>{{ row.accountName }} ({{ row.accountId }})</span>
          } @else {
            Account ({{ row.accountId }})
          }
        </td>
        <td class="col-user">{{ row.user }}</td>
        <td class="col-campaign">{{ row.campaignAdGroupName }}</td>
        <td class="col-start">
          @if (row.started) {
            @if (row.started?.date) {
              {{ row.started?.date.toLocaleString()  | date: 'short' }}
            } @else {
              {{ row.started.toLocaleString() | date: 'short' }}
            }
          } @else {
            -
          }
        </td>
        <td class="col-complete">
          @if (row.completed) {
            @if (row.completed?.date) {
              {{ row.completed?.date.toLocaleString()  | date: 'short' }}
            } @else {
              {{ row.completed | date: 'short' }}
            }
          } @else {
            -
          }
        </td>
        <td class="col-result">
          @if (row.result) {
            <span [ngClass]="{
              'result-succeeded': row.result === 'Succeeded',
              'result-skipped': row.result === 'Skipped',
              'result-failed': row.result === 'Failed',
              'result-in-progress': row.result === 'In Progress' || row.result === 'Started',
              'result-not-started': row.result === 'Not Started'
            }">{{ row.result }}</span>
          } @else {
            -
          }
        </td>
        <td class="col-error">
          @if (row.errorMessage && row.errorMessage.trim().length > 0) {
            <button pButton type="button" class="p-button-text p-button-sm view-error-btn" (click)="openErrorDialog(row)" label="View Error(s)"></button>
          } @else {
            -
          }
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty" colspan="7">
          @if (!loading && !executionId) {
            <span>Select an execution above to see details</span>
          }
          @if (!loading && executionId) {
            <span>No details found for this execution.</span>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="errorDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [style]="{width: '650px', maxWidth: '95vw'}"
    [contentStyle]="{'max-height':'20vh','overflow':'auto'}"
    [header]="errorDialogTitle">
    <div class="error-dialog-body">
      @if (errorDialogMessages?.length) {
        <ul class="error-list">
          @for (msg of errorDialogMessages; track msg) {
            <li [style]="{'margin':'0.5rem 0'}">{{ msg }}</li>
          }
        </ul>
      } @else {
        @if (errorDialogSingleMessage) {
          <div class="single-error" [style]="{'margin':'0.5rem 0'}">{{ errorDialogSingleMessage }}</div>
        }
        @if (!errorDialogSingleMessage) {
          <div>No error message provided.</div>
        }
      }
    </div>
  </p-dialog>
</div>
